<template>
    <el-dialog title="OCR识别记录" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false" :modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>用户名：</label>
                    <el-input v-model="search_Obj.f_user_name" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            </div>
            <div class="dataBox">
                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                    <el-table-column prop="user_name" label="用户名" sortable="custom"></el-table-column>
                    <el-table-column prop="real_name" label="用户姓名" sortable="custom"></el-table-column>
                    <el-table-column prop="add_time" label="记录时间" sortable="custom"></el-table-column>
                </el-table>
            </div>
            <div class="pageBox">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil"

export default {
    name: 'CountList',
    mixins: [listutil],
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        },
        data_id: {
            type: Number,
            default() {
                return -1;
            }
        },
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.search_Obj.f_pid1 = this.data_id
            if (newv) {
                this.getData()
            }
        }
    },
    data() {
        return {
            showflag: false,
            pagesize: 10,
            m_name: 'OCR识别记录',
            menu_id: 9999,
            list_url: "/api/admin/ocrcountlog/list",
            search_Obj: {
                f_pid1: '',
                f_user_name: '',
            },
            del_Obj:{
                url:'/api/admin/ocrcountlog/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
        };
    },
    methods: {
        closeDialog(){
            this.$emit("on-close")
        },
    }
};
</script>